import { createStyles, IconButton, makeStyles } from '@material-ui/core';
import React from 'react';
const useStyles = makeStyles(() => {
  return createStyles({
    iconButton: {
      display: 'inline-block'
    },
    iconActive: {},
    icon: {}
  });
});

/**
 * Represents a base toggle component
 */
export const ToggleBase = props => {
  const classes = useStyles(props);
  return /*#__PURE__*/React.createElement(IconButton, {
    disabled: props.disabled,
    className: classes.iconButton,
    color: props.active ? 'primary' : 'inherit',
    title: props.title,
    onClick: () => props.setValue(!props.active)
  }, props.children);
};
//# sourceMappingURL=toggle-base.js.map